import $ from 'jquery';
import 'jquery-match-height';

$(function() {
    let $elements = $('.match-height');

    if ($elements.length) {
        $elements.matchHeight();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/components/MatchHeight.js